import React from "react";
import { Route, Redirect } from "react-router-dom";

export default function ProtectedRoute({ component: Component, ...rest }) {
  const status = localStorage.getItem("isLogin");
  return (
    <Route
      render={(props) => {
        if (status) {
          return <Component {...props} {...rest} />;
        } else {
          localStorage.clear();
          return <Redirect to="/login"></Redirect>;
        }
      }}
    />
  );
}
